export enum PC_KEY_CODE {
  RIGHT_ARROW = 39,
  LEFT_ARROW = 37,
}
